import React from 'react'
import "./Product.css"
import { useStateValue } from './StateProvider'

function Product({id, title, image, price}) {
    const [{ basket }, dispatch] = useStateValue();

    // console.log('This is the basket >>> ', basket);

    const addToBasket = () => {
       
        // dispatch the item into the data layer

        dispatch({
            type: 'ADD_TO_BASKET',
            item: {
                id: id,
                title: title,
                image: image,
                price: price,
            }
        })
    }
    return (
        <div className='product'>
            <img src={image} alt=""/>
            
            <div className='product__info'>
                <p className='product_title'>{title}</p>
                <p className='product__price'>
                    <small>₹</small>
                    <strong>{price}</strong>
                </p>
                
            </div>

            
            <button onClick={addToBasket}>Add +</button>
        </div>
    )
}

export default Product
